import React, { useEffect, useState } from 'react'

export default function Header() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop
      setScrolled(y > 0)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={[
        'fixed left-0 right-0 top-0 z-40 w-full transition-[background-color,border-color,backdrop-filter] duration-300 ease-out',
        scrolled
          ? 'bg-[rgba(255,255,255,0.5)] backdrop-blur'
          : 'bg-transparent backdrop-blur-none',
      ].join(' ')}
    >
      <div className="mx-auto flex h-[92px] w-full items-center justify-between px-[80px] mobile:px-[16px]">
        <div className="flex items-center gap-4 mobile:gap-2">
          <a href="/" className="flex items-center gap-3 mobile:gap-2">
            <img src="/mozgi.svg" alt="Спайрон" className="h-9 w-9 mobile:h-7 mobile:w-7" />
            <div className="flex flex-col justify-center">
              <span className="text-[24px] mobile:text-[18px] font-semibold leading-8 mobile:leading-6 tracking-[-0.5px] text-[#1e293b]">
                Спайрон
              </span>
            </div>
          </a>
        </div>

        <nav className="flex items-center gap-8 mobile:gap-3">
          <a
            href="https://app.spairon.ru/login"
            className="whitespace-nowrap text-[16px] font-medium leading-none tracking-[-0.5px] text-[#111827CC] transition-colors duration-200 hover:text-[#111827]"
          >
            Вход
          </a>
          <a
            href="https://app.spairon.ru/login"
            className="flex h-11 min-h-[44px] items-center justify-center whitespace-nowrap rounded-[22px] bg-[#1d73ff] px-6 text-[16px] font-medium leading-none tracking-[-0.5px] text-white transition-colors duration-200 hover:bg-[#124FD7]"
          >
            Регистрация
          </a>
        </nav>
      </div>
    </header>
  )
}
